import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import Business from "./Business";

export default function Aboutus() {
    const serviceData = [
        {
            title: "Expertise and Innovation",
            description:
                "We deliver innovative IT solutions with deep industry knowledge and cutting-edge technology, keeping your business competitive and future-ready.",
            image: "images/inno.png", // Replace with the actual path to the png
        },
        {
            title: "Customer-Centric Approach",
            description:
                "We focus on your success with personalized solutions and unwavering support, ensuring we meet your unique goals.",
            image: "images/cus.png", // Replace with the actual path to the png
        },
        {
            title: "Comprehensive Solutions",
            description:
                "Our end-to-end IT services are flexible and scalable, addressing immediate needs while supporting long-term growth.",
            image: "images/sol.png", // Replace with the actual path to the SVG
        },
    ];
    return (
        <>
            <div className="aboutus_bg">
                <div className="aboutus-img-content">
                    <h1>About Us</h1>

                </div>

            </div>
            <div className="about-heading">
                {/* <h2 style={{ textAlign: 'center', color: '#0e2b5c' }}>About Us</h2> */}
                <p >We are a Qatar-based IT solutions provider specializing in Strategy and Consulting, Staffing and Resource Augmentation, and Digital Transformation.
                    Our mission is to empower businesses with innovative technology, aligning IT initiatives with strategic goals to drive efficiency and growth.
                    With a customer-centric approach and expert team, we deliver tailored solutions to optimize processes, enhance capabilities, and future-proof organizations.
                    Partner with us to unlock your digital potential and achieve sustainable success.</p>
            </div>
            <div className="whychoose mb-4">
                <h2 style={{ textAlign: 'center', color: '#0e2b5c' }}>Why Choose Us?</h2>
                <Container className="py-5 services-main">
                    <Row className="g-4">
                        {serviceData.map((service, index) => (
                            <Col sm={12} md={12} lg={4} key={index}>
                                <Card className="text-center shadow-sm h-100 services-it">
                                    <Card.Body>
                                        <Card.Title>{service.title}</Card.Title>
                                        <div className="card-img">
                                            <img
                                                src={service.image}
                                                alt={service.title}
                                                className="service-icon"
                                                style={{ width: "100px", marginBottom: "50px", marginTop: '35px' }}
                                            />
                                        </div>
                                        <Card.Text style={{ color: '#627792' }}>
                                            {service.description}
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </div>
            <Business />
        </>
    )
}